import { render, staticRenderFns } from "./MyRewardsDetails.vue?vue&type=template&id=4685da1c&scoped=true&"
import script from "./MyRewardsDetails.vue?vue&type=script&lang=js&"
export * from "./MyRewardsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4685da1c",
  null
  
)

export default component.exports